import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'app-store',
  storage: window.localStorage
})

// Create a new store instance.
const store = new Vuex.Store({
  state: {
    session: {
      token: '',
    },
    basket: {
      products: [],
      promotionalCodes: []
    },
  },
  getters: {
    hasToken(state) {
      return Boolean(state.session.token)
    }
  },
  mutations: {
    setToken(state, payload) {
      state.session.token = payload.token
    },
    setBasket(state, basketProducts) {
      state.basket.products = basketProducts
    },
    setPromotionalCodes(state, promotionalCodes) {
      state.basket.promotionalCodes = promotionalCodes
    }
  },
  plugins: [vuexPersist.plugin]
})

export default store